export default __webpack_public_path__ + "static/user-journey-landingpage-f61324d47d1ef02a6f8466c182fd6751.png";